import React, { useState } from 'react';
import SharedMaterialReactTable, { ISharedTableColumn } from "../Shared/MaterialReactTable";

// Simple test data
const testData = [
    { id: 1, name: "Item 1", isSelectable: true },
    { id: 2, name: "Item 2", isSelectable: false },
    { id: 3, name: "Item 3", isSelectable: true },
    { id: 4, name: "Item 4", isSelectable: true },
    { id: 5, name: "Item 5", isSelectable: false },
];

const TestRowSelection: React.FC = () => {
    const [selectedItems, setSelectedItems] = useState<number[]>([]);
    const [debugInfo, setDebugInfo] = useState<string[]>([]);

    const addDebugInfo = (message: string) => {
        setDebugInfo(prev => [...prev.slice(-10), `${new Date().toLocaleTimeString()}: ${message}`]);
    };

    const columns: ISharedTableColumn<any>[] = [
        {
            accessorKey: 'id',
            header: 'ID',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'name',
            header: 'Name',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'isSelectable',
            header: 'Selectable',
            enableSorting: true,
            enableFiltering: true,
            Cell: ({ row }) => row.original.isSelectable ? "Yes" : "No",
        },
    ];

    const isRowSelectable = (row: any) => {
        console.log('TestRowSelection isRowSelectable called:', row);
        addDebugInfo(`isRowSelectable called for row ${row.id}: ${row.isSelectable}`);
        return row.isSelectable;
    };

    return (
        <div style={{ padding: '20px' }}>
            <h1>Row Selection Test</h1>
            <p>Selected items: {selectedItems.join(', ')}</p>

            <div style={{ marginBottom: '20px', border: '1px solid #ccc', padding: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                <h3>Debug Info:</h3>
                {debugInfo.map((info, index) => (
                    <div key={index} style={{ fontSize: '12px', fontFamily: 'monospace' }}>{info}</div>
                ))}
            </div>

            <SharedMaterialReactTable
                data={testData}
                columns={columns}
                title="Test Table"
                isLoading={false}
                enablePagination={true}
                enableSorting={true}
                enableFiltering={true}
                enableColumnActions={true}
                enableRowActions={false}
                enableRowSelection={true}
                enableMultiRowSelection={true}
                enableSelectAll={true}
                isRowSelectable={isRowSelectable}
                getRowId={(row, index) => row.id.toString()}
                onRowSelectionChange={(updatedSelection) => {
                    console.log('TestRowSelection onRowSelectionChange:', updatedSelection);
                    addDebugInfo(`onRowSelectionChange called with keys: ${Object.keys(updatedSelection).join(', ')}`);

                    const selectedIds = Object.keys(updatedSelection)
                        .filter(key => updatedSelection[key])
                        .map(key => parseInt(key))
                        .filter(id => {
                            const item = testData.find(item => item.id === id);
                            return item && isRowSelectable(item);
                        });
                    console.log('TestRowSelection selectedIds:', selectedIds);
                    addDebugInfo(`Selected IDs: ${selectedIds.join(', ')}`);
                    setSelectedItems(selectedIds);
                }}
                initialState={{
                    pagination: { pageIndex: 0, pageSize: 10 },
                }}
                emptyMessage="No data found."
            />
        </div>
    );
};

export default TestRowSelection;
